import {HttpClient} from "@angular/common/http";
import {Component, OnInit, QueryList, ViewChild, ViewChildren} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {DataTableDirective} from "angular-datatables";
import {IOption} from "ng-select";
import {BsModalService} from "ngx-bootstrap/modal";
import {BsModalRef} from "ngx-bootstrap/modal/bs-modal-ref.service";
import {NgxSpinnerService} from "ngx-spinner";
import {Subject} from "rxjs/Subject";
import {CorrectiveActionAlmahaHistoryModalComponent} from "../../corrective-action-almaha-history-modal/corrective-action-almaha-history-modal.component";
import {CorrectiveActionModalComponent} from "../../corrective-action-modal/corrective-action-modal.component";
import {FindingsActionHistoryModalComponent} from "../../findings-action-history-modal/findings-action-history-modal.component";
import {AuthenticationService} from "../../services/authentication.service";
import {DmsAccessService} from "../../services/dms-access.service";
import {DownloadService} from "../../services/download.service";
import {HelperService} from "../../services/helper.service";
import {IncidentTypeService} from "../../services/incident-type.service";
import {LocationService} from "../../services/location.service";
import {RilrService} from "../../services/rilr.service";
import {TosterMessageService} from "../../services/toster-message.service";
import {CorrectiveActionAlmahaModalComponent} from "../../corrective-action-almaha-modal/corrective-action-almaha-modal.component";

@Component({
  selector: 'app-my-action-almaha-management',
  templateUrl: './my-action-almaha-management.component.html',
  styleUrls: ['./my-action-almaha-management.component.scss'],
  providers: [RilrService, IncidentTypeService, TosterMessageService, HelperService, LocationService, DownloadService, DmsAccessService],
})
export class MyActionAlmahaManagementComponent implements OnInit {

  public company: Array<IOption> = [];
  public priorityArr: Array<IOption> = [];
  public documentArr: Array<IOption> = [];
  public countriesArr: Array<IOption> = [];
  public employeeOptionCreatedBy: Array<IOption> = [];
  public employeeOptionPersonRes: Array<IOption> = [];
  public regionArr: Array<IOption> = [];
  public locationArr: Array<IOption> = [];
  public yearsArr: Array<IOption> = [];
  public monthArr: Array<IOption> = [];
  public departmentArr: Array<IOption> = [];
  public findingTypeArr: Array<IOption> = [];

  public isFilterEnabled: boolean;
  public isFilterEnabledCreatedByMeAction: boolean;
  public isFilterEnabledAllAction: boolean;
  public isFilterEnabledDepartment: boolean;
  public companySystemID: number = +this.helperService.getSelectedCompanyId();
  toolTipHtml: string;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChildren(DataTableDirective)
  dtElement: QueryList<DataTableDirective>;
  totalRec: Number;
  userType: Number;
  finalIndex: any;
  orderCondition: any;
  public actionOverDue: number = 0;

  public masterData: any = {};
  userAccess: any;

  bsModalRefCorrectiveActionHistory: BsModalRef;

  //@ViewChild(PageNotAccessSwalComponent) private notAccessSwal:PageNotAccessSwalComponent;

  notAccessAlertOpen() {
    //this.notAccessSwal.showModal();
  }

  allActionsTab: boolean = false;
  allDepartmentTab: boolean = false;
  selectedCorrectiveAction: any;

  reports: any[];
  reportsCreatedByMe: any[];
  allActionReports: any[];
  allActionDepartments: any[];
  filters: any = {};
  filtersCreatedByMeAction: any = {};
  filtersAllAction: any = {};
  filtersDepartment: any = {};
  selectedItem: any;
  message: string = "";
  documentSystemID: Number = 1;

  statusArr: any = [
    {value: 0, label: 'Open'},
    {value: 1, label: 'In Progress'},
    {value: 2, label: 'Closed'}
  ];
  public companyData: any = {};
  public regionData = [];
  public regionMySelectedItems = [];
  public regionAllSelectedItems = [];
  public regionDepartmentSelectedItems = [];
  public regionSettings = {};
  public correctiveActionDetail: any = {};
  public locationDataMy = [];
  public locationDataAll = [];
  public locationDataDepartment = [];
  public locationMySelectedItems = [];
  public locationAllSelectedItems = [];
  public locationDepartmentSelectedItems = [];
  public locationSettings = {};
  public enablePolicyBaseAction: boolean = false;
  public bsModalRefCorrectiveAction: BsModalRef;
  public bsValue = new Date();

  public documentData = [];
  public documentSelectedItems = [];
  public documentSettings = {};

  public departmentData = [];
  public departmentSelectedItems = [];
  public departmentSettings = {};

  @ViewChild('swalDeleteCorrectiveAction') swalDeleteCorrectiveAction: any;

  constructor(private tosterMessageService: TosterMessageService,
              private rilrService: RilrService,
              private incidentTypeService: IncidentTypeService,
              private route: ActivatedRoute,
              private http: HttpClient,
              private spinner: NgxSpinnerService,
              private locationService: LocationService,
              private downloadService: DownloadService,
              private dmsAccessService: DmsAccessService,
              private authenticationService: AuthenticationService,
              private modalService: BsModalService,
              private helperService: HelperService) {
    this.documentSystemID = this.helperService.getRouteDataByKey(this.route.snapshot, 'documentSystemID');
  }

  ngOnInit() {

    this.regionSettings = {
      singleSelection: false,
      text: "Select region",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      enableSearchFilter: true,
      badgeShowLimit: 1,
      classes: "myclass custom-class",
    };

    this.locationSettings = {
      singleSelection: false,
      text: "Select location",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      enableSearchFilter: true,
      badgeShowLimit: 1,
      classes: "myclass custom-class",
    };

    this.documentSettings = {
      singleSelection: false,
      text: "Select document",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      enableSearchFilter: true,
      badgeShowLimit: 1,
      classes: "myclass custom-class",
    };

    this.departmentSettings = {
      singleSelection: false,
      text: "Select department",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      enableSearchFilter: true,
      badgeShowLimit: 1,
      classes: "myclass custom-class",
    };

    const that = this;
    that.spinner.show();
    that.getFormData();
    that.userAccess = that.authenticationService.getUserGroupAccessRights(that.route.snapshot);
    const v = localStorage.getItem('DataTables_filter');
    if (v && v != null) {
      const DataTables_filter = JSON.parse(sessionStorage.getItem('DataTables_filter'));
      that.filters.documentSystemID = that.helperService.setSelectedValue(DataTables_filter.documentSystemID);
      that.isFilterEnabled = DataTables_filter.isFilterEnabled;
    }
    that.dtOptions[0] = {
      order: [[0, "desc"]],
      pagingType: 'full_numbers',
      pageLength: 100,
      lengthMenu: [5, 10, 15, 50, 100],
      serverSide: true,
      processing: true,
      stateSave: true,
      stateDuration: -1,
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.companySystemID = +(that.helperService.getSelectedCompanyId());
        if (that.isFilterEnabled) {
          dataTablesParameters.documentSystemID = this.filters.documentSystemID;
          dataTablesParameters.regionID = this.regionMySelectedItems;
          dataTablesParameters.priorityID = this.filters.priorityID;
          dataTablesParameters.locationID = this.locationMySelectedItems;
          dataTablesParameters.year = this.filters.year;
          dataTablesParameters.month = this.filters.month;
          dataTablesParameters.createdByUserSystemID = this.filters.createdByUserSystemID;
          dataTablesParameters.submitted = this.filters.submitted;
          dataTablesParameters.isDeleted = 0;
        }
        that.rilrService
          .getAllMyAssignedCAAlmaha()
          .post(dataTablesParameters)
          .subscribe(resp => {
            that.reports = resp.data.data;
            callback({
              recordsTotal: resp.data.recordsTotal,
              recordsFiltered: resp.data.recordsFiltered,
              data: []
            });
            that.totalRec = resp.data.recordsTotal;
            that.orderCondition = resp.data.orderCondition;
            that.spinner.hide();
          }, (error) => {
            that.spinner.hide();
          });
      },
      columns: [
        {data: 'DT_Row_Index', name: 'DT_Row_Index'}
      ],
      responsive: true
    };

    that.dtOptions[1] = {
      order: [[0, "desc"]],
      pagingType: 'full_numbers',
      pageLength: 100,
      lengthMenu: [5, 10, 15, 50, 100],
      serverSide: true,
      processing: true,
      stateSave: true,
      stateDuration: -1,
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.companySystemID = +(that.helperService.getSelectedCompanyId());
        if (that.isFilterEnabled) {
          dataTablesParameters.documentSystemID = this.filtersCreatedByMeAction.documentSystemID;
          dataTablesParameters.regionID = this.regionMySelectedItems;
          dataTablesParameters.priorityID = this.filtersCreatedByMeAction.priorityID;
          dataTablesParameters.locationID = this.locationMySelectedItems;
          dataTablesParameters.year = this.filtersCreatedByMeAction.year;
          dataTablesParameters.month = this.filtersCreatedByMeAction.month;
          dataTablesParameters.createdByUserSystemID = this.filtersCreatedByMeAction.createdByUserSystemID;
          dataTablesParameters.submitted = this.filtersCreatedByMeAction.submitted;
          dataTablesParameters.isDeleted = 0;
        }
        that.rilrService
          .getAllCACreatedByMeAlmaha()
          .post(dataTablesParameters)
          .subscribe(resp => {
            that.reportsCreatedByMe = resp.data.data;
            callback({
              recordsTotal: resp.data.recordsTotal,
              recordsFiltered: resp.data.recordsFiltered,
              data: []
            });
            that.totalRec = resp.data.recordsTotal;
            that.orderCondition = resp.data.orderCondition;
            that.spinner.hide();
          }, (error) => {
            that.spinner.hide();
          });
      },
      columns: [
        {data: 'DT_Row_Index', name: 'DT_Row_Index'}
      ],
      responsive: true
    };

    that.dtOptions[3] = {
      order: [[0, "desc"]],
      pagingType: 'full_numbers',
      pageLength: 100,
      lengthMenu: [5, 10, 15, 50, 100],
      serverSide: true,
      processing: true,
      stateSave: true,
      stateDuration: -1,
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.companySystemID = +(that.helperService.getSelectedCompanyId());
        if (that.isFilterEnabledAllAction) {
          dataTablesParameters.documentSystemID = this.filtersAllAction.documentSystemID;
          dataTablesParameters.departmentID = this.filtersAllAction.departmentID;
          dataTablesParameters.regionID = this.regionAllSelectedItems;
          dataTablesParameters.priorityID = this.filtersAllAction.priorityID;
          dataTablesParameters.locationID = this.locationAllSelectedItems;
          dataTablesParameters.year = this.filtersAllAction.year;
          dataTablesParameters.month = this.filtersAllAction.month;
          dataTablesParameters.createdByUserSystemID = this.filtersAllAction.createdByUserSystemID;
          dataTablesParameters.personResEmpSystemID = this.filtersAllAction.personResEmpSystemID;
          dataTablesParameters.submitted = this.filtersAllAction.submitted;
          dataTablesParameters.isDeleted = 0;
        }
        that.rilrService
          .getAllAssignedCALPTAlmaha()
          .post(dataTablesParameters)
          .subscribe(resp => {
            that.allActionReports = resp.data.data;
            callback({
              recordsTotal: resp.data.recordsTotal,
              recordsFiltered: resp.data.recordsFiltered,
              data: []
            });
            that.totalRec = resp.data.recordsTotal;
            that.orderCondition = resp.data.orderCondition;
            that.spinner.hide();
          }, (error) => {
            that.spinner.hide();
          });
      },
      columns: [
        {data: 'DT_Row_Index', name: 'DT_Row_Index'}
      ],
      responsive: true
    };

    that.dtOptions[2] = {
      order: [[0, "desc"]],
      pagingType: 'full_numbers',
      pageLength: 100,
      lengthMenu: [5, 10, 15, 50, 100],
      serverSide: true,
      processing: true,
      stateSave: true,
      stateDuration: -1,
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.companySystemID = +(that.helperService.getSelectedCompanyId());
        if (that.isFilterEnabledDepartment) {
          dataTablesParameters.documentSystemID = this.filtersDepartment.documentSystemID;
          dataTablesParameters.departmentID = this.filtersDepartment.departmentID;
          dataTablesParameters.regionID = this.regionDepartmentSelectedItems;
          dataTablesParameters.locationID = this.locationDepartmentSelectedItems;
          dataTablesParameters.priorityID = this.filtersDepartment.priorityID;
          dataTablesParameters.year = this.filtersDepartment.year;
          dataTablesParameters.month = this.filtersDepartment.month;
          dataTablesParameters.createdByUserSystemID = this.filtersDepartment.createdByUserSystemID;
          dataTablesParameters.submitted = this.filtersDepartment.submitted;
          dataTablesParameters.isDeleted = 0;
        }
        that.rilrService
          .getAllAssignedCADepartmentAlmaha()
          .post(dataTablesParameters)
          .subscribe(resp => {
            that.allActionDepartments = resp.data.data;
            callback({
              recordsTotal: resp.data.recordsTotal,
              recordsFiltered: resp.data.recordsFiltered,
              data: []
            });
            that.totalRec = resp.data.recordsTotal;
            that.orderCondition = resp.data.orderCondition;
            that.spinner.hide();
          }, (error) => {
            that.spinner.hide();
          });
      },
      columns: [
        {data: 'DT_Row_Index', name: 'DT_Row_Index'}
      ],
      responsive: true
    };

    that.modalService.onHide.subscribe((reason: string, event) => {
      if (reason) {
        if (reason === 'corrective_action_closed') {
          that.filterApply();
          that.filterApply2();
          that.filterApply3();
          that.filterApply4();
        }
        if (reason === 'corrective_action_edit_closed') {
          that.filterApply();
          that.filterApply2();
          that.filterApply3();
          that.filterApply4();
        }

        if (reason === 'corrective_action_success') {
          that.filterApply4();
        }
      }
    });

  }

  public getFormData() {
    const that = this;
    that.incidentTypeService
      .getIncidentFormData()
      .get({companyId: +(that.helperService.getSelectedCompanyId())})
      .subscribe(data => {
        let resp = data.data.data;
        that.documentArr = that.helperService.setSelect2DropDownOptionsConcatLabel(resp.document, 'documentSystemID', 'documentID', 'documentDescription');
        that.documentData = that.helperService.setMultipleselectDropDown(resp.document, "documentSystemID", "documentDescription");
        that.regionData = that.helperService.setMultipleselectDropDown(resp.region, "id", "regionName");
        that.departmentData = that.helperService.setMultipleselectDropDown(resp.department, "departmentID", "description");
        that.priorityArr = that.helperService.setSelect2DropDownOptions(resp.priority, 'priorityID', 'description');
        that.countriesArr = that.helperService.setSelect2DropDownOptions(resp.country, "countryID", "countryName");
        /*  that.regionArr = that.helperService.setSelect2DropDownOptions(resp.region, "id", "regionName");*/
        that.yearsArr = that.helperService.setSelect2DropDownOptions(resp.years, 'value', 'label');
        that.monthArr = that.helperService.setSelect2DropDownOptions(resp.months, 'value', 'label');
        that.departmentArr = that.helperService.setSelect2DropDownOptions(resp.department, 'departmentID', 'description');
        that.findingTypeArr = that.helperService.setSelect2DropDownOptions(resp.finding_types, "autoID", "description");
        that.userType = resp.userType;
        that.companyData = resp.company;
        if (that.companyData.policyBaseCActionAdd == 1) {
          that.enablePolicyBaseAction = true;
        }
        if (that.userType == 2) {
          that.allActionsTab = true;
          that.allDepartmentTab = true;
        }
        that.allDepartmentTab = true;
      }, (error) => {
      });
  }

  /*filter apply*/
  filterApply(): void {
    var i = 1;
    this.dtElement.forEach((dtElement: DataTableDirective) => {
      if (i === 1) {
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.draw();
        });
      }
      i++;
    });
  }

  filterApply2(): void {
    var i = 1;
    this.dtElement.forEach((dtElement: DataTableDirective) => {
      if (i === 2) {
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.draw();
        });
      }
      i++;
    });
  }

  filterApply3(): void {
    var i = 1;
    this.dtElement.forEach((dtElement: DataTableDirective) => {
      if (i === 3) {
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.draw();
        });
      }
      i++;
    });
  }

  filterApply4(): void {
    var i = 1;
    this.dtElement.forEach((dtElement: DataTableDirective) => {
      if (i === 4) {
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.draw();
        });
      }
      i++;
    });
  }

  employeeDeselect() {
    this.employeeOptionCreatedBy = [];
    this.filterApply2();
  }

  indexOrder(value) {
    return this.helperService.indexOrder(value, this.orderCondition, this.totalRec);
  }

  mouseEnterToolTip(data) {
    this.toolTipHtml = data;
  }

  mouseLeaveToolTip() {
    this.toolTipHtml = "";
  }

  filterEnable() {
    this.isFilterEnabled = !this.isFilterEnabled;
    if (!this.isFilterEnabled) {
      this.filters = {};
      this.regionMySelectedItems = [];
      this.locationDataMy = [];
      this.locationMySelectedItems = [];
      this.filterApply();
    }
  }

  filterEnableCreatedByMe() {
    this.isFilterEnabledCreatedByMeAction = !this.isFilterEnabledCreatedByMeAction;
    if (!this.isFilterEnabledCreatedByMeAction) {
      this.filters = {};
      this.regionMySelectedItems = [];
      this.locationDataMy = [];
      this.locationMySelectedItems = [];
      this.filterApply();
    }
  }

  filterEnableAllAction() {
    this.isFilterEnabledAllAction = !this.isFilterEnabledAllAction;
    if (!this.isFilterEnabledAllAction) {
      this.filtersAllAction = {};
      this.regionAllSelectedItems = [];
      this.locationAllSelectedItems = [];
      this.locationDataAll = [];
      this.filterApply2();
    }
  }

  filterEnableDepartment() {
    this.isFilterEnabledDepartment = !this.isFilterEnabledDepartment;
    if (!this.isFilterEnabledDepartment) {
      this.filtersAllAction = {};
      this.regionDepartmentSelectedItems = [];
      this.locationDataDepartment = [];
      this.locationDepartmentSelectedItems = [];
      this.filterApply2();
    }
  }

  public typeHeadCreatedBy(value: any): void {
    const that = this;
    if (value.length > 2) {
      that.getActionCreatedBy(value);
    } else {
      that.employeeOptionCreatedBy = [];
    }
  }

  public getActionCreatedBy(value: any) {
    const that = this;
    that.incidentTypeService
      .getTypeheadEmployees()
      .get({
        'search': value,
        'companySystemID': this.companySystemID
      })
      .subscribe(resp => {
        let tempOption = resp.data.data;
        that.employeeOptionCreatedBy = [];
        that.employeeOptionCreatedBy = that.helperService.setSelect2DropDownOptionsConcatLabelThree(tempOption, 'employeeSystemID', 'empName', 'countryName', 'description');
      }, (err) => {
        that.employeeOptionCreatedBy = [];
      });
  }

  public typeHeadPersonResponsible(value: any): void {
    const that = this;
    if (value.length > 2) {
      that.getActionPersonResponsible(value);
    } else {
      that.employeeOptionPersonRes = [];
    }
  }

  public getActionPersonResponsible(value: any) {
    const that = this;
    that.incidentTypeService
      .getTypeheadEmployees()
      .get({
        'search': value,
        'companySystemID': this.companySystemID
      })
      .subscribe(resp => {
        let tempOption = resp.data.data;
        that.employeeOptionPersonRes = [];
        that.employeeOptionPersonRes = that.helperService.setSelect2DropDownOptionsConcatLabelThree(tempOption, 'employeeSystemID', 'empName', 'countryName', 'description');
      }, (err) => {
        that.employeeOptionPersonRes = [];
      });
  }

  public edit(reportdata) {
    const that = this;
    that.spinner.show();
    if (reportdata.documentSystemID == 1) {
      that.helperService.go("create-new-entry/incident-edit-alkhorayef/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 2) {
      that.helperService.go("audit-management/audit-edit-almaha/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 3) {
      that.helperService.go("meetings/meeting-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 4) {
      that.helperService.go("audit-management/management-visit-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 6) {
      that.helperService.go("audit-management/self-assessment-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 7) {
      that.helperService.go("create-new-entry/observation-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 8) {
      that.helperService.go("create-new-entry/accident-report-edit-almaha/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 10) {
      that.helperService.go("management-of-change/management-of-change-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 11) {
      that.helperService.go("audit-management/non-conformance-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 12) {
      that.helperService.go("create-new-entry/emergency-response-drill-edit-alkhorayef/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 14) {
      that.helperService.go("create-new-entry/permit-to-work-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 15) {
      if (reportdata.incidentType == 1) {
        that.helperService.go('audit-management/inspection-edit-almaha/' + reportdata.reportSystemID);
      } else if (reportdata.incidentType == 3) {
        that.helperService.go('audit-management/hiab-inspection-edit-almaha/' + reportdata.reportSystemID);
      } else if (reportdata.incidentType == 4) {
        that.helperService.go('audit-management/vehicle-inspection-edit-almaha/' + reportdata.reportSystemID);
      } else if (reportdata.incidentType == 5) {
        that.helperService.go('audit-management/mobile-crane-inspection-edit-almaha/' + reportdata.reportSystemID);
      } else if (reportdata.incidentType == 6) {
        that.helperService.go('audit-management/environment-inspection-edit-almaha/' + reportdata.reportSystemID);
      } else if (reportdata.incidentType == 7) {
        that.helperService.go('audit-management/fuel-tanker-inspection-edit-almaha/' + reportdata.reportSystemID);
      } else if (reportdata.incidentType == 9) {
        that.helperService.go('audit-management/scaffolding-inspection-edit-almaha/' + reportdata.reportSystemID);
      } else if (reportdata.incidentType == 10) {
        that.helperService.go('audit-management/legal-compliance-inspection-edit-almaha/' + reportdata.reportSystemID);
      } else if (reportdata.incidentType == 11) {
        that.helperService.go('audit-management/site-hse-inspection-edit-almaha/' + reportdata.reportSystemID);
      } else if (reportdata.incidentType == 13) {
        that.helperService.go('audit-management/tool-box-talk-inspection-edit-almaha/' + reportdata.reportSystemID);
      } else if (reportdata.incidentType == 14) {
        that.helperService.go('audit-management/tankers-daily-inspection-edit-almaha/' + reportdata.reportSystemID);
      } else {
        that.helperService.go("audit-management/inspection-edit-almaha/" + reportdata.reportSystemID);
      }
    }
    that.spinner.hide();
  }

  public viewActionTracker(actionID, inspectedby) {
    const that = this;
    that.spinner.show();
    that.rilrService
      .reportCorrectiveActionsHistory()
      .get({actionID: actionID})
      .subscribe(data => {
        let resp = data.data.data;
        if (resp.masterType == 2) {
          that.bsModalRefCorrectiveActionHistory = that.modalService.show(FindingsActionHistoryModalComponent, {
            class: "modal-xlg",
            backdrop: "static",
          });
          that.bsModalRefCorrectiveActionHistory.content.masterData = resp;
          that.bsModalRefCorrectiveActionHistory.content.priorityArr = that.priorityArr;
          that.bsModalRefCorrectiveActionHistory.content.departmentArr = that.departmentArr;
          that.bsModalRefCorrectiveActionHistory.content.findingTypeArr = that.findingTypeArr;
          that.bsModalRefCorrectiveActionHistory.content.actionID = actionID;
          that.bsModalRefCorrectiveActionHistory.content.inspectedByChecklist = inspectedby;
          that.bsModalRefCorrectiveActionHistory.content.masterData.priorityID = that.helperService.setSelectedValue(resp.priorityID);
          that.bsModalRefCorrectiveActionHistory.content.masterData.submitted = that.helperService.setSelectedValue(resp.submitted);
          that.bsModalRefCorrectiveActionHistory.content.masterData.personResEmpSystemID = that.helperService.setSelectedValue(resp.personResEmpSystemID);
          that.bsModalRefCorrectiveActionHistory.content.masterData.departmentID = that.helperService.setSelectedValue(resp.departmentID);
          that.bsModalRefCorrectiveActionHistory.content.masterData.findingTypeID = that.helperService.setSelectedValue(resp.findingTypeID);
          that.bsModalRefCorrectiveActionHistory.content.masterData.deviationID = that.helperService.setSelectedValue(resp.deviationID);
        } else {
          that.bsModalRefCorrectiveActionHistory = that.modalService.show(CorrectiveActionAlmahaHistoryModalComponent, {
            class: "modal-xlg",
            backdrop: "static",
          });
          that.bsModalRefCorrectiveActionHistory.content.masterData = resp;
          that.bsModalRefCorrectiveActionHistory.content.priorityArr = that.priorityArr;
          that.bsModalRefCorrectiveActionHistory.content.departmentArr = that.departmentArr;
          that.bsModalRefCorrectiveActionHistory.content.actionID = actionID;
          that.bsModalRefCorrectiveActionHistory.content.inspectedByChecklist = inspectedby;
          that.bsModalRefCorrectiveActionHistory.content.masterData.priorityID = that.helperService.setSelectedValue(resp.priorityID);
          that.bsModalRefCorrectiveActionHistory.content.masterData.submitted = that.helperService.setSelectedValue(resp.submitted);
          that.bsModalRefCorrectiveActionHistory.content.masterData.personResEmpSystemID = that.helperService.setSelectedValue(resp.personResEmpSystemID);
          that.bsModalRefCorrectiveActionHistory.content.masterData.departmentID = that.helperService.setSelectedValue(resp.departmentID);
        }

      }, (error) => {
      });
  }

  processLocationRegion(regionID) {
    let that = this;
    that.locationArr = [];
    that.locationService
      .getLocationsByRegion()
      .get({regionID: regionID, companySystemID: +(that.helperService.getSelectedCompanyId())})
      .subscribe((data) => {
        var resp = data.data.data;
        that.locationArr = that.helperService.setSelect2DropDownOptions(resp, 'autoID', 'description');
      }, () => {
      });
  }

  public exportToCSV() {
    const that = this;
    that.spinner.show();
    that.filtersAllAction.companySystemID = that.companySystemID;
    const headersConfig = that.downloadService.createAuthHeader();
    const filename: string = 'api/v1/exportAllActionsAlMaha';
    that.http.post(filename, that.filtersAllAction,
      {
        headers: headersConfig
      }
    ).subscribe(data => {
      that.spinner.hide();
    }, (error) => {
      that.spinner.hide();
      if (error.status == 200) {
        let dt = Date.now();
        that.dmsAccessService.downloadFile2(error.error.text, 'text/csv', 'report_' + dt + '.csv');
      } else {
        that.tosterMessageService.showError('Error', 'Unable to export report csv');
      }
    });
  }

  removeCorrectiveActionConfirm(action) {
    this.selectedCorrectiveAction = action;
    this.swalDeleteCorrectiveAction.show();
  }

  removeCorrectiveAction() {
    let that = this;
    that.rilrService
      .reportCorrectiveActionsUD(that.selectedCorrectiveAction.actionID)
      .remove()
      .subscribe(resp => {
        that.tosterMessageService.showSuccess("Success", "Successfully deleted the corrective action");
        that.filterApply2();
      }, (error) => {
        that.tosterMessageService.showError("Error", error.data.message);
      });
  }

  cancelDelete() {

  }

  public countryChange(tab) {
    const that = this;
    const datas: any = {};
    datas.companySystemID = that.companySystemID;
    if (tab === 'my') {
      datas.regionSelectedItems = that.regionMySelectedItems;
      that.locationDataMy = [];
    } else if (tab === 'all') {
      datas.regionSelectedItems = that.regionAllSelectedItems;
      that.locationDataAll = [];
    } else if (tab === 'department') {
      datas.regionSelectedItems = that.regionDepartmentSelectedItems;
      that.locationDataDepartment = [];
    }
    that.locationService
      .getSelectedRegionLocationsMulti()
      .post(datas)
      .subscribe((data) => {
        const resp = data.data.data;
        if (resp.location != null) {
          if (tab === 'my') {
            that.locationDataMy = that.helperService.setMultipleselectDropDown(resp.location, "autoID", "description");
          } else if (tab === 'all') {
            that.locationDataAll = that.helperService.setMultipleselectDropDown(resp.location, "autoID", "description");
          } else if (tab === 'department') {
            that.locationDataDepartment = that.helperService.setMultipleselectDropDown(resp.location, "autoID", "description");
          }
        }
      }, (error) => {

      });
  }

  public createCorrectiveAction() {
    const that = this;
    that.correctiveActionDetail = {};
    that.bsModalRefCorrectiveAction = that.modalService.show(CorrectiveActionAlmahaModalComponent, {
      class: 'modal-lg',
      keyboard: false,
      backdrop: 'static'
    });
    that.bsModalRefCorrectiveAction.content.isEdit = 0;
    that.bsModalRefCorrectiveAction.content.reportID = 0;
    that.bsModalRefCorrectiveAction.content.documentSystemID = 0;
    that.bsModalRefCorrectiveAction.content.policyBaseAction = 1;
    that.bsModalRefCorrectiveAction.content.myActionBase = 1;
    that.bsModalRefCorrectiveAction.content.masterData = that.correctiveActionDetail;
    that.bsModalRefCorrectiveAction.content.masterData.targetDate = that.bsValue;
    //that.bsModalRefCorrectiveAction.content.masterData.completionDate = that.bsValue;
    that.bsModalRefCorrectiveAction.content.priorityArr = that.priorityArr;
    that.bsModalRefCorrectiveAction.content.departmentArr = that.departmentArr;
    that.bsModalRefCorrectiveAction.content.masterData.submitted = that.helperService.setSelectedValue(0);
    //that.bsModalRefCorrectiveAction.content.masterData.departmentID = that.helperService.setSelectedValue(1);
  }

}



// WEBPACK FOOTER //
// /app/src/app/my-action-items/my-action-almaha-management/my-action-almaha-management.component.ts